import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import { lazy, Suspense } from "react";
import PrivateRoute from "./components/PrivateRoute.js";

const Loading = lazy(() => import("./components/Loading.js"));
const Login = lazy(() => import("./pages/Login.js"));
const Verify = lazy(() => import("./pages/Verify.js"));
const Register = lazy(() => import("./pages/Register.js"));
const Home = lazy(() => import("./pages/Home.js"));
const Upload = lazy(() => import("./pages/Upload.js"));
const Rewards = lazy(() => import("./pages/Rewards.js"));
const UploadSuccess = lazy(() => import("./pages/UploadSuccess.js"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/* <SessionMonitor> */}
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/home"
              element={
                <PrivateRoute>
                  <Home />
                </PrivateRoute>
              }
            />
            <Route
              path="/upload"
              element={
                <PrivateRoute>
                  <Upload />
                </PrivateRoute>
              }
            />
            <Route
              path="/rewards"
              element={
                <PrivateRoute>
                  <Rewards />
                </PrivateRoute>
              }
            />
            <Route
              path="/upload-success"
              element={
                <PrivateRoute>
                  <UploadSuccess />
                </PrivateRoute>
              }
            />
            {/* Default */}
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </Suspense>
        {/* </SessionMonitor> */}
      </BrowserRouter>
    </div>
  );
}

export default App;
